import {type GetterTree} from 'vuex';
import store from './index';

const getters: GetterTree<RootState, RootState> = {
    employeeId(state)
    {
        return 'employeeId' in state.layoutData.user ? state.layoutData.user.employeeId : 0;
    },
    exists(state)
    {
        return (id: number, type = 'user') =>
        {
            let stateKey = type + 's';
            if (typeof state[stateKey][id] === 'undefined')
            {
                store.dispatch(
                    'fetchPerson',
                    {
                        type,
                        id,
                    },
                );

                return null;
            }
            else if (!state[stateKey][id])
            {
                return false;
            }

            return true;
        };
    },
    personName(state, getters)
    {
        return (id: number, type = 'user') =>
        {
            return getters.personData(id, type).name;
        };
    },
    personData(state): (id: number, type: string) => User
    {
        return (id: number, type = 'user'): User =>
        {
            let stateKey = 'entity' === type ? 'entities' : type + 's';

            if (typeof state[stateKey][id] === 'undefined')
            {
                store.dispatch(
                    'fetchPerson',
                    {
                        type,
                        id,
                    },
                );

                return {
                    id: 0,
                    ind: 0,
                    name: 'Name wird geladen...',
                    prename: '',
                    surname: 'Name wird geladen...',
                    active: 1,
                    paths: {
                        huge: null,
                        large: null,
                        medium: null,
                        preview: null,
                    },
                };
            }
            else if (!state[stateKey][id])
            {
                return {
                    id: 0,
                    ind: 0,
                    name: 'Gelöschter Benutzer',
                    prename: '',
                    surname: 'Gelöschter Benutzer',
                    active: 1,
                    paths: {
                        huge: null,
                        large: null,
                        medium: null,
                        preview: null,
                    },
                };
            }

            return state[stateKey][id];
        };
    },
    bookmarkList(state)
    {
        return state.bookmark.list;
    },
    employeeConfiguration(state)
    {
        return state.layoutData.employee_configuration || {};
    },
    isFreeIntranet(state)
    {
        return state.layoutData.freeIntranet || false;
    },
    hasClient(state)
    {
        return state.layoutData.hasClient || false;
    },
    currentUser(state)
    {
        return state.layoutData.user || false;
    },
    calendarMinuteHeight(state)
    {
        return state.calendarHourHeight / 60;
    },
    sentryActive(state)
    {
        return state.layoutData.sentryActive || false;
    },
};

export default getters;